import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fetchAddress_loading: false,
    fetchAddress_data: null,
    fetchAddress_error: null,
    fetchAddress_success: false
  };
  
const FetchAddressSlice = createSlice({
  name: 'FetchAddressSlice',
  initialState,
  reducers: {
    FetchAddressServiceInit(state) {
      state.fetchAddress_loading = true;
      state.fetchAddress_error = null;
      state.fetchAddress_data =  null;
      state.fetchAddress_success = false;
    },
    FetchAddressServiceSuccess(state, action) {
      state.fetchAddress_loading = false;
      state.fetchAddress_data = action.payload;
      state.fetchAddress_success = true
    },
    FetchAddressServiceFailure(state, action) {
      state.fetchAddress_loading = false;
      state.fetchAddress_error = action.payload;
      state.fetchAddress_success = false
    }
  },
});

export const { 
  FetchAddressServiceInit, 
  FetchAddressServiceSuccess, 
  FetchAddressServiceFailure
} = FetchAddressSlice.actions;

export default FetchAddressSlice.reducer;
